import { __ } from "@wordpress/i18n";
import { useMemo, useState } from "@wordpress/element";
import { Conversations } from "./conversations";
import { ChatbotConfig } from "./config";
import { css } from "@/utils/css";
import { CHAT_CONFIG } from "@/utils/constants";
import { useRoute } from "@/hooks/use-route";
import { Tabs } from "@/components/tabs";
import { useConversations } from "@/hooks/use-conversations";

export default function Chatbot() {
    const [config, setConfig] = useState({ ...CHAT_CONFIG });
    const { navigate, query } = useRoute();
    const { data: conversations } = useConversations();

    const tabs = [
        {
            value: "configuration",
            label: __("Configuration", "antimanual"),
            title: __("Chatbot Configuration", "antimanual"),
            description: __("Configure the chatbot settings to customize its behavior and responses.", "antimanual"),
            element: <ChatbotConfig config={config} setConfig={setConfig} />,
        },
        {
            value: "conversations",
            title: __("Chatbot Conversations", "antimanual"),
            label: __("Conversations", "antimanual") + ` (${conversations?.length || 0})`,
            description: __("View and manage past conversations with the chatbot.", "antimanual"),
            element: <Conversations />,
        },
    ];

    const activeTab = useMemo(() => tabs.find((sect) => sect.value === query.tab) || tabs[0], [query.tab, config]);

    return (
        <div className={css("chatbot")}>
            <Tabs standalone tabs={tabs} activeTab={activeTab.value} onTabChange={(value) => navigate(`?page=${query.page}&tab=${value}`)} />
            <div className={css("pb-5 pt-2 px-2")}>
                <h2>{activeTab.title}</h2>
                <p>{activeTab.description || ""}</p>
            </div>
            <div className={css("panel")}>{activeTab.element}</div>
        </div>
    );
}
